import React from "react";

/**
 * Reusable mobile popup that slides up from the bottom bar. Closes from the
 * cross icon or a tap on the dimmed backdrop. While it is open the page
 * behind it does not scroll (see `.footer-submenu-container.show-sub-menu`
 * in styles.scss).
 */
export default function MobileBottomSheet({
  id,
  open,
  title,
  onClose,
  children,
}) {
  const closeOnBackdrop = (event) => {
    if (event.target === event.currentTarget) onClose();
  };

  return (
    <div
      id={id}
      onClick={closeOnBackdrop}
      className={`${open ? "show-sub-menu" : "hide-sub-menu"} footer-submenu-container`}
      aria-hidden={!open}
    >
      <div
        className="games-menu p-3"
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="mobile-sheet-header">
          <p className="mb-0">{title}</p>
          <button
            type="button"
            className="mobile-sheet-close"
            aria-label="Close"
            onClick={onClose}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
